import React from "react";
import { useForm } from "react-final-form";

import {
    ReferenceInput,
    TextInput,
    AutocompleteInput,
    NumberInput,
    BooleanInput,
    required,
} from "react-admin"

import {
    TableCell,
    TableRow,
} from "@material-ui/core";

export const PhagesHostsFields = (props) => {
    const index = props.index;
    const DeleteButton = props.deleteButton;

    const form = useForm();
    var formdata = form.getState().values;
    const values = formdata.phages_hosts;
    let isExternal = values[index].is_external_isolate;
    if (!isExternal) {
        return (<TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >


            <TableCell component="th" scope="row">
                <ReferenceInput
                    label="Isolates"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].id_isolate`}
                    reference="isolates"
                    validate={required()}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="code"
                        shouldRenderSuggestions={(value) => value.trim().length > 1}
                        suggestionLimit={10}
                    />
                </ReferenceInput>
            </TableCell>
            <TableCell align="left">
                <NumberInput
                    label="Concentration"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].concentration`} />
            </TableCell>
            <TableCell align="left">
                <NumberInput
                    label="Quantificaction"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].quantification`}
                />
            </TableCell>
            <TableCell align="left">
                <BooleanInput
                    label="Kills"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].kills`}
                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Intensity"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].intensity`}
                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Susceptibility"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].susceptibility`}

                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Notes"
                    source={`${props.source ?? 'phages_host_ranges'}[${index}].notes`} />
            </TableCell>
            <DeleteButton index={index}></DeleteButton>
        </TableRow>);
    }
    return (null);
}